import { RowData, JsonSchema } from "../../../../types";
import { getExportSchemaTitles, getSchemaSections } from "../schemaHelpers";
import { formatCellValue } from "../exportRecordsHelpers";
import { CONDITIONAL_EXPORT_FIELDS } from "../../constants";

export const flattenCOARowData = (
  rowData: RowData[],
  schema: JsonSchema,
): RowData[] => {
  const { schemaTitles, exportableFields } = getFieldsAndTitles(
    rowData,
    schema,
  );

  return rowData.map((row) => flattenRow(row, schemaTitles, exportableFields));
};

const getFieldsToExport = (schema: JsonSchema): Set<string> => {
  const sections = getSchemaSections(schema);

  const fieldsToExport = new Set(
    sections.flatMap((section) => section.sectionValue),
  );
  return fieldsToExport;
};

const flattenRow = (
  row: RowData,
  schemaTitles: Record<string, string>,
  exportableFields: Set<string>,
): RowData => {
  const flattened: RowData = {};

  for (const key of exportableFields) {
    const label = schemaTitles[key] || key;
    flattened[label] = formatCellValue(row[key]);
  }

  return flattened;
};

const getFieldsAndTitles = (
  rowData: RowData[],
  schema: JsonSchema,
): {
  schemaTitles: Record<string, string>;
  exportableFields: Set<string>;
} => {
  const schemaTitles = getExportSchemaTitles(schema);
  const exportableFields = getFieldsToExport(schema);

  const importMetadata = CONDITIONAL_EXPORT_FIELDS.find(({ condition }) =>
    rowData.some(condition),
  );

  if (!importMetadata) {
    return { schemaTitles, exportableFields };
  }

  importMetadata.fields.forEach(({ key, title }) => {
    schemaTitles[key] = title;
  });

  return {
    schemaTitles,
    exportableFields: new Set([
      ...importMetadata.fields.map(({ key }) => key),
      ...exportableFields,
    ]),
  };
};